/**
 * AI整改描述生成服务
 */

export interface GenerateRectifyDescriptionParams {
  imageUrls: string[]
  intention?: string
  userId?: string | number | null
  onStreamUpdate?: (chunk: string) => void
}

const API_CONFIG = {
  host: 'https://test.xhey.top',
  path: '/next/app/h5/xaiapi/chat/completionStream/v2',
  agentId: 143,
  apiKey: '1988871387251228672'
}

const DEFAULT_SESSION_PREFIX = 'rectify-ai'

const readStream = async (
  response: Response,
  onStreamUpdate?: (chunk: string) => void
) => {
  const reader = response.body?.getReader()
  if (!reader) {
    throw new Error('AI接口返回内容为空')
  }

  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  let fullText = ''

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    const chunkText = decoder.decode(value, { stream: true })
    buffer += chunkText

    const lines = buffer.split('\n')
    buffer = lines.pop() || ''

    let currentEvent = ''
    let currentData = ''

    for (const line of lines) {
      if (line.trim() === '') {
        if (currentEvent === 'msg' && currentData) {
          try {
            const payload = JSON.parse(currentData)
            if (payload?.contentType === 1) {
              fullText += payload.content || ''
              if (onStreamUpdate) {
                onStreamUpdate(fullText)
              }
            } else if (payload?.contentType === 2 && payload?.content) {
              // 一些接口会在结束时返回总结类的content
              fullText += payload.content || ''
              if (onStreamUpdate) {
                onStreamUpdate(fullText)
              }
            }
          } catch (error) {
            console.error('AI流式JSON解析失败:', error, currentData)
          }
        }
        currentEvent = ''
        currentData = ''
      } else if (line.startsWith('event:')) {
        currentEvent = line.substring(6).trim()
      } else if (line.startsWith('data:')) {
        currentData = line.substring(5).trim()
      }
    }
  }

  return fullText
}

export const generateRectifyDescription = async ({
  imageUrls,
  intention = '',
  userId,
  onStreamUpdate
}: GenerateRectifyDescriptionParams) => {
  if (!imageUrls || imageUrls.length === 0) {
    throw new Error('请先选择至少一张照片')
  }

  const cleanImageUrls = imageUrls.filter((url) => !!url)
  if (!cleanImageUrls.length) {
    throw new Error('照片缺少有效的URL，无法调用AI')
  }

  const userIdentifier =
    (userId && String(userId)) || `${DEFAULT_SESSION_PREFIX}-${Date.now()}`

  const payload = {
    userID: userIdentifier,
    agentID: API_CONFIG.agentId,
    apiKey: API_CONFIG.apiKey,
    questionType: 13,
    questionData: JSON.stringify({
      imageList: cleanImageUrls,
      intention: intention?.trim() || ''
    })
  }

  const response = await fetch(`${API_CONFIG.host}${API_CONFIG.path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })

  if (!response.ok || response.status !== 200) {
    const errorText = await response.text().catch(() => '')
    throw new Error(
      `AI接口请求失败：${response.status} ${response.statusText} ${
        errorText || ''
      }`
    )
  }

  const result = await readStream(response, onStreamUpdate)

  if (!result?.trim()) {
    throw new Error('AI未返回可用内容，请稍后再试')
  }

  return result.trim()
}
